export default {
  ARRIVAL_NOT_ROUNDED: `<0>{{ arrivalTime }}</0> <1>{{ arrivalDate }}</1>`,
  ARRIVAL_ROUNDED: `<0>{{ arrivalTime }}</0> (rounded <0>{{ arrivalRoundedTime }}</0>) <1>{{ arrivalDate }}</1>`,
  LEAVE_NOT_ROUNDED: `<0>{{ leaveTime }}</0> <1>{{ leaveDate }}</1>`,
  LEAVE_ROUNDED: `<0>{{ leaveTime }}</0> (rounded <0>{{ leaveRoundedTime }}</0>) <1>{{ leaveDate }}</1>`,
  SHIFT_HOURS: `<0>{{ position }}</0> {{ start }} <0>{{ startTime }}</0> - <0>{{ endTime }}</0>`,
  PLANNED_HOURS: `<0>{{ shift }}</0> scheduled`,
  BREAK_HOURS: `<0>{{ unpaidBreak }}</0> unpaid breaks`,
  PRESENT_HOURS: `<0>{{ present }}</0> clocked in`,
  PAID_HOURS: `<0>{{ paid }}</0> paid`,
  CREATE: `Create a punch card`,
  VALIDATION_VIEW: `Validation view`,
  ABSENT_OR_ON_VACATION: `The employee is absent or on vacation`,
  REGULAR_VIEW: `Back to regular view`,
  PUNCH_CARD_REQUIRES_ACTION: `One punch card requires attention!`,
  PUNCH_CARD_REQUIRES_ACTION_other: `{{ count }} punch cards require attention!`,
  SHIFTS_WITH_NO_PUNCH_CARD: `One shift does not have a corresponding punch card!`,
  SHIFTS_WITH_NO_PUNCH_CARD_other: `{{ count }} shifts do not have corresponding punch cards!`,
  PHONE_NUMBER: `Phone number`,
  DELETE_BUTTON: {
    TITLE: `Delete this punch card`,
    SUMMARY: `Are you sure you want to delete this punch card?`,
    PRIMARY_ACTION: `Delete`
  },
  LOCATION: {
    LABEL: `Launch the Punch Terminal at this location:`,
    DESCRIPTION: ``
  },
  USER_ID: `User`,
  SUMMARY: `Summary`,
  HOURS_SUMMARY: `Total hours`,
  ADDITIONAL_INFORMATION: `Additional info`,
  FLAGS: ``,
  BREAKS: `Breaks`,
  TRANSFERS: `Transfers`,
  TRANSFER_POSITION: `Position transfer`,
  TRANSFER_PROJECT: `Project transfer`,
  WAGE_PREMIUMS: `Wage premiums`,
  DISABLED_OVERWRITE_OVERTIME: `Overtime calculation disabled`,
  PROJECT: `Project`,
  TEAM: `Team`,
  ARRIVAL: `Arrival`,
  DEPARTURE: `Departure`,
  EXPECTED_LOCATION: `Expected location`,
  LEAVE: `Leave`,
  ARRIVAL_LOCATION: `Arrival location`,
  LEAVE_LOCATION: `Departure location`,
  ARRIVAL_COORDINATES: `Arrival coordinates`,
  LEAVE_COORDINATES: `Departure coordinates`,
  ARRIVAL_COORDINATES_ERROR: `Arrival coordinates do not match expected location`,
  LEAVE_COORDINATES_ERROR: `Departure coordinates do not match expected location`,
  APPROVED_MANUALLY: `Approved manually`,
  DISABLE_ARRIVAL_ROUNDING: `Arrival rounding disabled`,
  DISABLE_LEAVE_ROUNDING: `Leave rounding disabled`,
  DATE_RANGE_EXCEEDED: {
    TITLE: `Date range exceeded`,
    DESCRIPTION: `You tried to load too many punch cards, please set a date filter no longer than 4 weeks.`
  },
  NO_DATE_FILTER: {
    TITLE: `No date filter`,
    DESCRIPTION: `Please set a date filter to load punch cards.`
  },
  LIST: {
    TITLE: `Punch card list`,
    SUMMARY: ``
  },
  flags: {
    PUNCHED_IN_EARLY_DETAIL: `{{ time }} early`,
    PUNCHED_IN_LATE_DETAIL: `{{ time }} late`,
    PUNCHED_OUT_EARLY_DETAIL: `{{ time }} early`,
    PUNCHED_OUT_LATE_DETAIL: `{{ time }} late`,
    ISINEARLY: `Punched in too early`,
    ISINLATE: `Punched in too late`,
    ISOUTEARLY: `Punched out too early`,
    ISOUTLATE: `Punched out too late`,
    NOTPUNCHEDIN: `Did not punch in`,
    NOTPUNCHEDOUT: `Did not punch out`,
    NOSHIFT: `No associated shift`,
    DUPLICATECARD: `Duplicate punch card`,
    MISSINGPUNCHRULES: `Missing punch rules`,
    NOCLOCKEDTIME: `No clock time`,
    LOCATION_CONFLICTS: `Punch location conflicts`
  },
  STATUSES: {
    APPROVED: `Approved`,
    APPROVAL_REQUIRED: `Manual approval required`,
    PUNCH_RULE_APPROVAL: `Approve using punch rules`,
    NEEDS_CORRECTION: `Needs corrections`,
    NO_SHIFT: `No shift associated`,
    MISSING_PUNCH_RULES: `No punch rules associated to position`,
    null: `No status`
  },
  csv: {
    CSV_NAME: `punch_list_export_{{ range }}`
  },
  pdf: {
    PDF_NAME: `punch_list_export_{{ range }}`,
    TITLE: `Punch validation report`,
    GENERATED_BY: `Generated by`,
    NAME: `Name`,
    DATE: `Date`,
    DAY: `Day`,
    SHIFT: `Shift`,
    SHIFTTOTAL: `Shift duration`,
    SHIFT_TOTAL: `Total hours planned`,
    WORKED: `Worked`,
    WORKEDROUNDED: `Rounded`,
    WORKEDTOTAL: `Paid duration`,
    WORKED_TOTAL: `Total hours paid`,
    DIFFERENCE: `Difference`,
    POSITION: `Position`
  },
  CREATE_PUNCH_CARDS_MODAL: {
    TITLE: `Create punch cards`,
    SUMMARY: `Punch cards will be created for each of the selected unpunched shifts.`,
    DESCRIPTION: `The created punch cards will need to be be verified and approved.`,
    ERROR_LOADING: `Error loading unpunched shifts`,
    ERROR_CREATING_CARDS: `Error creating punch cards`,
    LOCKEDPUNCHCARD: `This shift is locked`,
    ISABSENT: `This employee is absent`,
    ISONTIMEOFF: `This employee is on time off`,
    CREATEFORABSENCETIMEOFF: 'Create punch cards for employees that are absent or on time off'
  },
  LAUNCH_PUNCH_TERMINAL_MODAL: {
    TITLE: `Lauch Punch Terminal`,
    SUMMARY: ``
  },
  diffs: {
    SEE_MODIFICATIONS: `See modification history`,
    TITLE: `Punch card edit history`,
    SUMMARY: ``,
    TIMESTAMP: `<1>{{ time }}</1> on {{ date }} by <0>{{ name }}</0>`,
    BEFORE: `Before`,
    AFTER: `After`,
    NO_BREAKS: `No breaks`,
    NO_TRANSFERS: `No transfers`,
    NO_WAGE_PREMIUMS: `No wage premiums`,
    USERID_ASSIGNED: `<1>{{ after }}</1> assigned`,
    USERID_UNASSIGNED: `<0>{{ before }}</0> unassigned`,
    USERID_CHANGED: `<1>{{ after }}</1> assigned instead of <0>{{ before }}</0>`,
    SHIFT_ASSOCIATED: `Associated to a shift`,
    SHIFT_UNASSOCIATED: `Unassociated from a shift`,
    SHIFT_CHANGED: `Associated shift was changed`,
    POSITIONID_CHANGED: `Position changed from <0>{{ before }}</0> to <1>{{ after }}</1>`,
    ARRIVAL_CHANGED: `Arrival time changed from <0>{{ before }}</0> to <1>{{ after }}</1>`,
    ARRIVAL_ADDED: `Arrival time added <1>{{ after }}</1>`,
    ARRIVAL_REMOVED: `Arrival time removed`,
    LEAVE_CHANGED: `Departure time changed from <0>{{ before }}</0> to <1>{{ after }}</1>`,
    LEAVE_ADDED: `Departure time added <1>{{ after }}</1>`,
    LEAVE_REMOVED: `Departure time removed`,
    BREAKS_CHANGED: `Breaks were changed`,
    TRANSFERS_CHANGED: `Transfers were changed`,
    WAGE_PREMIUMS_CHANGED: `Wage premiums were changed`,
    STATUS_CHANGED: `Status changed from <0>{{ before }}</0> to <1>{{ after }}</1>`,
    ARRIVAL_ROUNDING_DISABLED: `Arrival rounding was disabled`,
    ARRIVAL_ROUNDING_ENABLED: `Arrival rounding was enabled`,
    LEAVE_ROUNDING_DISABLED: `Departure rounding was disabled`,
    LEAVE_ROUNDING_ENABLED: `Departure rounding was enabled`,
    APPROVED_MANUALLY: `Approved manually`,
    UNAPPROVED_MANUALLY: `Approval removed manually`
  },
  form: {
    COMMENT: `Employee comment:`,
    NO_SHIFT: `No shift`,
    ARRIVAL_MUST_BE_BEFORE_LEAVE: `Arrival time must be before departure time.`,
    SHIFT_HAS_CHANGED_SINCE_PUNCH_CREATION: `The shift has been changed since the punch card was created and they no longer match, click here to sync the shift information to the punch card.`,
    LONG_PUNCHCARD_WARNING: `This punch card has a duration longer than 12 hours. Please verify that the hours are correct.`,
    CREATE: {
      TITLE: `Create a punch card`,
      SUMMARY: ``
    },
    EDIT: {
      TITLE: `Edit a punch card`,
      SUMMARY: ``
    },
    BREAKS_TRANSFERS_PREMIUMS_PROJECTS: `Project, Breaks, Transfers, and Premiums`,
    BREAKS: {
      LABEL: `Breaks`,
      SUMMARY: `Add paid and unpaid breaks to the punch card`,
      UNPLANNED: `Unplanned break`,
      NEW_BREAK: `New break`,
      NOT_CONTAINED_IN_PUNCH_CARD: `Break time is not between start and end of punch card.`
    },
    TRANSFERS: {
      TITLE: `Transfers`,
      SUMMARY: `Add transfers to the punch card`,
      NEW_TRANSFER: `New transfer`,
      NOT_CONTAINED_IN_PUNCH_CARD: `Transfer time is not between start and end of punch card.`
    },
    USERID: {
      LABEL: `Employee`,
      DESCRIPTION: ``
    },
    RANGE_TO_LOAD_SHIFTS: {
      LABEL: `Range to check for shifts`,
      DESCRIPTION: `Used to load shifts into the shift field, based on the selected range and employee.`
    },
    SHIFTID: {
      LABEL: `Shift`,
      DESCRIPTION: `If no shifts appear, check the selected employee and set the date of the punch card.`,
      EMPTY_PLACEHOLDER: `No matching shifts`
    },
    STATUS: {
      LABEL: `Status`,
      DESCRIPTION: ``
    },
    ADDITIONALINFO: {
      LABEL: `Additional info`,
      PLACEHOLDER: `Enter info here`,
      DESCRIPTION: `Used to add context to the punch card or indicate specific actions to be taken in regard to the hours worked.`
    },
    REFERENCEDATE: {
      LABEL: `Date`,
      DESCRIPTION: ``
    },
    ARRIVALTIME: {
      LABEL: `Arrival time`,
      PLACEHOLDER: ``,
      DESCRIPTION: ``
    },
    DISABLEARRIVALROUNDING: {
      LABEL: `Disable arrival rounding`,
      DESCRIPTION: ``
    },
    ARRIVAL_ROUNDED: `Arrival time rounded to <0>{{ arrivalTimeRounded }}</0>`,
    CLEAR_ARRIVAL: `Clear arrival time`,
    LEAVETIME: {
      LABEL: `Departure time`,
      PLACEHOLDER: ``,
      DESCRIPTION: ``
    },
    DISABLELEAVEROUNDING: {
      LABEL: `Disabled departure rounding`,
      DESCRIPTION: ``
    },
    LEAVE_ROUNDED: `Leave time rounded to <0>{{ leaveTimeRounded }}</0>`,
    CLEAR_LEAVE: `Clear departure`,
    BREAKSTART: {
      LABEL: `Start`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Time that the break was started.`
    },
    BREAKEND: {
      LABEL: `End`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Time that the break was ended.`
    },
    BREAKPAID: {
      LABEL: `Paid`,
      DESCRIPTION: `Used to indicate whether or not the break duration should be paid.`
    },
    BREAKREASON: {
      LABEL: `Reason`,
      DESCRIPTION: `Used to add information on why the break was taken.`,
      PLACEHOLDER: `Add a short description to the break.`
    },
    TRANSFERSTART: {
      LABEL: `Transfer time`,
      PLACEHOLDER: ``,
      DESCRIPTION: `Time at which the transfer was initiated.`
    },
    TRANSFERTOPOSITION: {
      LABEL: `Position`,
      DESCRIPTION: `Position to which the employee transferred.`
    },
    TRANSFERTOPROJECT: {
      LABEL: `Project`,
      DESCRIPTION: `Project to which the employee transferred.`
    },
    PROJECTID: {
      LABEL: `Project`,
      PLACEHOLDER: `Select a project`,
      DESCRIPTION: ``
    },
    TEAMID: {
      LABEL: `Team`,
      PLACEHOLDER: `Select a team`,
      DESCRIPTION: ``
    },
    TAGS: {
      LABEL: `Tags`,
      PLACEHOLDER: `Select tags`,
      DESCRIPTION: ``
    }
  },
  validation: {
    LIST: {
      TITLE: `Punch card validation`,
      SUMMARY: ``
    },
    TOTAL_PLANNED: `<0>{{ totalPlanned }}</0> hours planned total`,
    TOTAL_WORKED: `<0>{{ totalRegular }}</0> hours worked total`,
    PLANNED_HOURS_SINGLE: `Planned <0>{{ shiftStart }}-{{ shiftEnd }}</0>`,
    WORKED_HOURS_SINGLE: `Clocked <0>{{ workedStart }}-{{ workedEnd }}</0>`,
    ROUNDED_HOURS_SINGLE: `Paid <0>{{ workedStartRounded }}-{{ workedEndRounded }}</0>`,
    PLANNED_DURATION: `Planned duration (with breaks) <0>{{ shiftTotal }}</0>`,
    WORKED_DURATION: `Clocked duration (without breaks) <0>{{ workedTotal }}</0>`,
    PAID_DURATION: `Paid duration (without breaks) <0>{{ paidTotal }}</0>`,
    DIFFERENCE: `Difference <0>{{ difference }}</0>`
  },
  UNPLANNED: `Unplanned: {{reason}}`,
  PAID: `PAID`,
  NOT_ENDED_YET: `Not ended yet`,
  IMPORT_PUNCH: `Import punch cards`,
  PUNCH_CARD_LOCKED: `This punch card is locked, please contact your administrator to edit/create it.`,
  PUNCH_CARD_LOCKED_CAN_EDIT: `This punch card is locked, but you can still edit it.`,
  LOCK_PUNCH_CARDS: `Lock punch cards`,
  PUNCH_LOCK_DATE_MODAL: {
    TITLE: `Modify punch cards locking date`,
    SUMMARY: ``,
    PUNCHCARDLOCKDATE: {
      LABEL: `Locking date`,
      DESCRIPTION: `It will only be possible to create or edit punch cards that start after this date.`,
      PLACEHOLDER: `Enter a date`
    }
  },
  import: {
    TITLE: {
      TITLE: `Import punch cards`,
      SUMMARY: ``
    },
    EMPLOYEE_NUMBER: `Employee number`,
    EMPLOYEENUMBER_DESC: `The employee number found in the employee file in Merinio.`,
    POSITION_CODE: `Position code`,
    POSITIONCODE_DESC: `Must be a position code as chosen by your administrator.`,
    DATE: `Date`,
    DATE_DESC: `Punch date must be in <1>YYYY-MM-DD</1> format, for example January 30th 2010  would be <1>2010-01-30</1>.`,
    TIME: `Time`,
    TIME_DESC: `Punch time must be in <1>HH:mm</1> format, for example 2PM would be <1>14:00</1>.`,
    DOWNLOAD_TEMPLATE: `Download template`,
    MISSING_HEADERS: `Missing the following header: <0>{{value}}</0>`,
    MISSING_HEADERS_other: `Missing the following headers: <0>{{value}}</0>`,
    TEMPLATE_FILE_NAME: `Punch_import`,
    PUNCHES_SAVING_FAILED: `There was <0>{{count}}</0> punch that were not saved.`,
    PUNCHES_SAVING_FAILED_other: `There were <0>{{count}}</0> punches that were not saved.`,
    PUNCHES_NOT_VALID: `There is <0>{{count}}</0> invalid field.`,
    PUNCHES_NOT_VALID_other: `There are <0>{{count}}</0> invalid fields.`,
    SHIFT: `Shift`,
    NO_SHIFT: `No shift`,
    ARRIVAL: `Arrival`,
    DEPARTURE: `Departure`,
    NO_DEPARTURE: `No departure`
  },
  SHIFT_DUPLICATED: `The selected shift already has a punch card. Click here to view it.`,
  CREATE_A_SHIFT: `No shifts selected, select one from the dropdown or click here to create one.`,

  DATE_FILTER_CHANGED: `Date filter changed`,
  PUNCH_CARD_NOT_CONTAINED_IN_FILTER: `The punch card you edited was not contained in your filter.`,
  SEE_EMPLOYEE_SCHEDULE: `See employee schedule`
}
